import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_BEGIN,
  DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_SUCCESS,
  DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_FAILURE,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteGithubExportRequest(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/code-export/github/${args.uuid}`,
        header,
      );

      doRequest.then(
        (res) => {
          const { success } = res.data;
          if (success) {
            dispatch({
              type: DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_SUCCESS,
              data: args.uuid,
            });
            toast.success('GitHub export setting deleted successfully');
            resolve(res);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_FAILURE,
              data: { error: 'Failed to delete GitHub export request' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_FAILURE,
            data: { error: err.message },
          });
          toast.error(`Error: ${err.message}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_BEGIN:
      return {
        ...state,
        deleteGithubExportRequestPending: true,
        deleteGithubExportRequestError: null,
      };

    case DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_SUCCESS:
      return {
        ...state,
        deleteGithubExportRequestPending: false,
        deleteGithubExportRequestError: null,
        githubExportList: state.githubExportList.filter((item) => item.uuid !== action.data),
      };

    case DEPLOYMENT_SETTING_DELETE_GITHUB_EXPORT_REQUEST_FAILURE:
      return {
        ...state,
        deleteGithubExportRequestPending: false,
        deleteGithubExportRequestError: action.data.error,
      };

    default:
      return state;
  }
}
